import React from 'react';
import { CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { formatPrice } from '../../../utils/formatter';

const AnalyticCharts = ({ data }) => {
  const formatYAxis = (tick) => {
    if (tick >= 1000) {
      return `${(tick / 1000).toFixed(1)}K`;
    }
    return tick;
  };

  const formatXAxis = (tick) => {
    const date = new Date(tick);
    return date.toLocaleString('uk-UK', { month: 'short' });
  };

  return (
    <div className="flex-col border">
      <div className="w-full m-4 md:m-6 text-xs md:text-base font-header1">Дохід за рік</div>
      <ResponsiveContainer width="100%" height={200}>
        <LineChart
          data={data}
          margin={{
            top: 0,
            right: 30,
            left: 10,
            bottom: 0,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month" className="text-xs" tickFormatter={formatXAxis} />
          <YAxis dataKey="total" className="text-xs" tickFormatter={formatYAxis} />
          <Tooltip content={<CustomTooltip />} />
          <Line type="monotone" dataKey="total" stackId="1" stroke="#d35400" fill="#dc7633" activeDot={{ r: 8 }} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

const CustomTooltip = ({ payload, label, active }) => {
  if (!active || !payload || payload.length === 0) {
    return null;
  }

  const value = payload[0].value;
  const date = new Date(label);

  return (
    <div className="bg-white border p-3 shadow-lg text-sm">
      <p className="font-header1 text-gray-700">Місяць: {date.toLocaleString('uk-UK', { month: 'long' })}</p>
      <p className="text-gray-600">{`${formatPrice(value)} грн`}</p>
    </div>
  );
};

export default AnalyticCharts;
